import React, { useEffect, useState } from 'react';
import {
  guideType, maxBasedBrokerId, monopattiniPackage, safeCapitalizeWords,
} from '../../constants';
import {
  QuoteInformationResultContainer,
  QuoteInformationResultItem,
  CompanyInfoElements,
  CompanyInformationContainer,
} from '../../components/redesignComponents/ResultPageComponents/v2/SelectedQuoteCard.styles';
import infoIcon from '../../../assets/redesign_icons/info-icon.svg';
import CasaInfoModal from '../../components/redesignComponents/Modal/CasaInfoModal';
import RcFamigliaNobisModal from '../../components/redesignComponents/Modal/RcFamigliaNobisModal';
import { downloadResourceDocs } from '../../../services/axios-client/axeCommons';
import preContractIcon from '../../../assets/redesign_icons/pre-contract-icon.svg';
import GlobalAssistanceInfoModal from '../../components/redesignComponents/Modal/GlobalAssistanceTutelaInfoModal';
import InvaliditaPermanenteInfortunio from '../../components/redesignComponents/Modal/InvaliditaPermanenteInfortunio';
import AmtrustInfoModal from '../../components/redesignComponents/Modal/AmTrustInfoModal';
import TutelaLegaleInfoModal from '../../components/redesignComponents/Modal/TutelaLegaleInfoModal';
import MalattiaNobisModal from '../../components/redesignComponents/Modal/MalattiaNobisModal';
import CondominioNobisModal from '../../components/redesignComponents/Modal/CondominioNobisModal';
import ProfessionInfoModal from '../../components/redesignComponents/Modal/ProfessionInfoModal';
import ProfessionWeBindModal from '../../components/redesignComponents/Modal/ProfessionWeBindModal';
import AncillariInfoModal from '../../components/redesignComponents/Modal/AncillariInfoModal';
import AdriaticInfoModal from '../../components/redesignComponents/Modal/AdriaticInfoModal';
import PrimaInfoModal from '../../components/redesignComponents/Modal/PrimaInfoModal';
import GenialPiuInfoModal from '../../components/redesignComponents/Modal/GenialPiuInfoModal';
import SanitariaStranieriInfoModal from '../../components/redesignComponents/Modal/SanitariaStranieriInfoModal';
import SaluteInfoModal from '../../components/redesignComponents/Modal/SaluteInfoModal';

function QuoteInfoComponentResult({
  quote,
  requestInfo,
  profession,
  setExtraText,
  set_informativi,
  extensions,
  selectableExtensions,
  docs,
  guaranteesPrima,

}) {
  const [showModal, setShowModal] = useState(false);
  const [showInfortunioModal, setShowInfortunioModal] = useState(false);
  const [showModalTutelaCircolazione, setShowModalTutelaCircolazione] = useState(false);

  useEffect(() => {
    let defaultText = `Frequenza pagamento: ${quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'
    } `;

    if (requestInfo?.guide_type) {
      defaultText += `- Guida: ${guideType.find((v) => v.id === requestInfo.guide_type).name
      } `;
    }

    if (quote.company_id === 1) {
      defaultText
        += "- Emissione: Tradizionale -  Risarcimento: Rc con Risarcimento Diretto e RFS - Massimale: 6'450'000€  Danni a persone, 1'050'000€ Danni a cose";
    }

    if (
      quote.company_id === 3
      || quote.company_id === 9
      || quote.company_id === 10
      || quote.company_id === 17
      || quote.company_id === 21
      || quote.company_id === 22
      || quote.added_manually === 1
      || (quote.added_manually === 0 && quote.company_id === null)
    ) {
      defaultText
        += "- Emissione: Tradizionale -  Risarcimento: Rc con Risarcimento Diretto e RFS - Massimale: 6'450'000€  Danni a persone, 1'050'000€ Danni a cose";
    }

    if (quote.company_id === 2) {
      defaultText
        += "- Emissione: Diretta -  Risarcimento: Rc con Risarcimento Diretto e RFS - Massimale: 6'450'000€  Danni a persone, 1'050'000€ Danni a cose";
    }

    if (
      quote.company_id === 11
      || quote.company_id === 12
      || quote.company_id === 13
      || quote.company_id === 14
    ) {
      defaultText
        += '- Emissione: Tradizionale -  Risarcimento: Rc con Risarcimento Diretto e RFS';
      if (quote.massimale != 0) {
        defaultText += `- Massimale: ${quote.massimale}`;
      }
      if (quote.isotermici) {
        defaultText += `- Isotermici: ${quote.isotermici}`;
      }
    }

    if (quote.company_id === 16) {
      defaultText += '- Emissione: Tradizionale ';
      if (quote.massimale != 0) {
        defaultText += `- Massimale: ${new Intl.NumberFormat().format(
          quote.massimale,
        )}`;
      }
    }

    if (quote.company_id === 4) {
      defaultText += `Professione: ${profession.profession_desc
      } - Massimale: ${Number(profession.billed_maximum).toLocaleString(
        'it-IT',
        {
          minimumFractionDigits: 2,
        },
      )} - Franchigia: 1,000€ - Retroattività: ${profession.retroactivity_name
      } - Scaglione fatturato: ${profession.billed
      } - Tempo medio di emissione: 2 giorni`;
    }

    if (quote.company_id === 1002) {
      defaultText += `Professione: ${profession.profession_desc} - Massimale: ${Number(profession.billed_maximum).toLocaleString('it-IT', { minimumFractionDigits: 2 })} - Retroattività: ${profession.retroactivity_name} - Scaglione fatturato: ${profession.billed}`;
    }

    if (quote.company_id === 8 && quote.product_id == 11) {
      if (quote.risk_massimale) {
        defaultText += `- Massimale: ${Number(
          quote.risk_massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
      if (quote.massimale) {
        defaultText += `- Massimale: ${Number(
          quote.massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
    }
    if (quote.company_id === 8 && quote.product_id == 13) {
      defaultText += '- Emissione: Tradizionale ';
      if (quote.massimale != 0 && quote.massimale !== null) {
        defaultText += `- Massimale: ${new Intl.NumberFormat().format(
          quote.massimale,
        )} €`;
      }
      if (quote.quote_type === 'collisione') {
        defaultText += '- Franchigia: 200 €';
      }
    }

    if (quote.company_id === 15) {
      defaultText += '- Emissione: Tradizionale - Frequenza pagamento: Annuo';
      if (quote.massimale != 0) {
        defaultText += `- Massimale: ${parseFloat(quote.massimale).toFixed(
          2,
        )} €`;
      }
    }

    if (quote.company_id === 8 && quote.product_id == 12) {
      if (quote.risk_massimale) {
        defaultText += `- Massimale: ${Number(
          quote.risk_massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
      if (quote.massimale) {
        defaultText += `- Massimale: ${Number(
          quote.massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
        ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
      }
    }

    if (requestInfo.product_id == 1000 && quote.company_id === 19 && quote.massimale) {
      defaultText += `- Massimale: ${Number(
        quote.massimale.replace(/[,.](?=\d{3})/g, '').replace(',', '.'),
      ).toLocaleString('it-IT', { minimumFractionDigits: 2 })} €`;
    }

    if (quote.product_name) {
      defaultText += `- Nome Prodotto: ${quote.product_name}`;
    }

    setExtraText(defaultText);
  }, [quote]);

  const openModal = () => {
    setShowModal(!showModal);
  };

  // const openFamigliaNobisModal = () => {
  //   setShowFamigliaNobisModal(!showFamigliaNobisModal);
  // };

  const openInfortunioModal = () => {
    setShowInfortunioModal(!showInfortunioModal);
  };

  const openTutelaCircolazioneModal = () => {
    setShowModalTutelaCircolazione(!showModalTutelaCircolazione);
  };

  const getSubProductName = (subProduct) => {
    if (subProduct === 'professioni_sanitarie') return 'Professioni Sanitarie';
    if (subProduct === 'medici_dipendenti') return 'Medici Dipendenti';
    if (subProduct === 'medico_protetto') return 'Medico Protetto';
    if (subProduct === 'medici_liberi_professionisti') return 'Medici Liberi Professionisti';

    return '';
  };

  return (
    <>

      {showModal && quote.company_id === 16 && (
        <GlobalAssistanceInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {showModal && quote.company_id === 19 && quote.product_id === 15 && (
        <AmtrustInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {showModal && quote.company_id === 4 && quote.product_id === 4 && (
        <ProfessionInfoModal
          userData={quote}
          setShowModal={setShowModal}
          docs={docs}
          set_informativi={set_informativi}
          extensions={extensions}
          requestToken={requestInfo}
          selectableExtensions={selectableExtensions}
          profession={profession}
        />
      )}
      {showModal && quote.company_id === 1002 && quote.product_id === 4 && (
        <ProfessionWeBindModal
          userData={quote}
          setShowModal={setShowModal}
          docs={docs}
          set_informativi={set_informativi}
          extensions={extensions}
          requestToken={requestInfo}
          selectableExtensions={selectableExtensions}
          profession={profession}
        />
      )}

      {showModal && (quote.company_id === 1 || quote.company_id === 17) && (
        <AdriaticInfoModal quotation={quote} setShowModal={setShowModal} />
      )}
      {showModal && quote.company_id === 2 && (
        <PrimaInfoModal
          setShowModal={setShowModal}
          quote={quote}
          guaranteesPrima={guaranteesPrima}
        />
      )}

      {showModal && quote.company_id === 18 && (
        <GenialPiuInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {showModal && (quote.company_id == 8 && quote.product_id == 14) && (
        <SanitariaStranieriInfoModal setShowModal={setShowModal} requestInfo={requestInfo} />
      )}

      {quote.company_id === 1 && (
        <>
          <QuoteInformationResultContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {quote.product_id === 1 && (

              <CompanyInfoElements
                onClick={() => downloadResourceDocs(1, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
            {quote.product_id === 3 && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(5, 0)}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}

          </QuoteInformationResultContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>Adriatic Assicurazioni</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Risarcimento:</h6>
              <p>
                Rc con
                {' '}
                <b>Risarcimento</b>
                {' '}
                <br />
                {' '}
                <b>Diretto</b>
                {' '}
                e
                {' '}
                <b>RFS</b>
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
        </>
      )}
      {(quote.company_id === 3
        || quote.company_id === 9
        || quote.company_id === 10
        || quote.company_id === 17
        || quote.company_id === 21
        || quote.company_id === 22
        || quote.added_manually === 1
        || (quote.added_manually === 0 && quote.company_id === null)) && (
          <>
            <QuoteInformationResultContainer>
              {quote.company_id === 17 && quote.product_id === 1 && (
                <>
                  <CompanyInfoElements onClick={() => openModal()}>
                    <img src={infoIcon} alt="" />
                    <p>Maggiori informazioni</p>
                  </CompanyInfoElements>
                  <CompanyInfoElements
                    onClick={() => downloadResourceDocs(18, 0)}
                    title="Informativa Precontrattuale"
                  >
                    <img src={preContractIcon} alt="" />
                    <p>Informativa Precontrattuale</p>
                  </CompanyInfoElements>
                </>
              )}
              {quote.company_id === 17 && quote.product_id === 3 && (
                <>
                  <CompanyInfoElements onClick={() => openModal()}>
                    <img src={infoIcon} alt="" />
                    <p>Maggiori informazioni</p>
                  </CompanyInfoElements>
                  <CompanyInfoElements
                    onClick={() => downloadResourceDocs(20, 0)}
                    title="Informativa Precontrattuale"
                  >
                    <img src={preContractIcon} alt="" />
                    <p>Informativa Precontrattuale</p>
                  </CompanyInfoElements>
                </>
              )}

              {quote.company_id === 9 && quote.product_id === 1 && (
                <CompanyInfoElements onClick={() => downloadResourceDocs(17, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>

              )}

              {quote.company_id === 9 && quote.product_id === 2 && (
                <CompanyInfoElements onClick={() => downloadResourceDocs(21, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              )}

              {quote.company_id === 9 && quote.product_id === 3 && (
                <CompanyInfoElements onClick={() => downloadResourceDocs(50, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              )}
            </QuoteInformationResultContainer>

            <QuoteInformationResultContainer>
              <QuoteInformationResultItem>
                <h6>Compagnia:</h6>
                <p>
                  {quote.company
                    ? quote.company.name
                    : quote.preventivas_company.company_name}
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationResultItem>
            </QuoteInformationResultContainer>
            <QuoteInformationResultContainer>
              <QuoteInformationResultItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  <b>
                    {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                    &euro;
                  </b>
                  {' '}
                  Danni a persone
                  <br />
                  <b>
                    {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                    &euro;
                  </b>
                  {' '}
                  Danni a cose
                </p>
              </QuoteInformationResultItem>
            </QuoteInformationResultContainer>
          </>
      )}
      {quote.company_id === 18
        && (
          <>
            <CompanyInformationContainer>
              <CompanyInfoElements onClick={() => setShowModal(!showModal)}>
                <img src={infoIcon} alt="" />
                <p>Maggiori informazioni</p>
              </CompanyInfoElements>

              {quote.product_id === 1 && (
                <CompanyInfoElements onClick={() => downloadResourceDocs(19, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              )}

              {quote.product_id === 2 && (
                <CompanyInfoElements onClick={() => downloadResourceDocs(28, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              )}

              {quote.product_id === 3 && (
                <CompanyInfoElements onClick={() => downloadResourceDocs(29, 0)} title="Informativa Precontrattuale">
                  <img src={preContractIcon} alt="" />
                  <p>Informativa Precontrattuale</p>
                </CompanyInfoElements>
              )}
            </CompanyInformationContainer>
            <QuoteInformationResultContainer>
              <QuoteInformationResultItem>
                <h6>Compagnia:</h6>
                <p>
                  {quote.company
                    ? quote.company.name
                    : quote.preventivas_company.company_name}
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationResultItem>
            </QuoteInformationResultContainer>
            <QuoteInformationResultContainer>
              <QuoteInformationResultItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationResultItem>
              {quote.risk_massimale
                && (
                  <QuoteInformationResultItem>
                    <h6>Massimale:</h6>
                    <p>
                      {quote.risk_massimale}
                    </p>
                  </QuoteInformationResultItem>
                )}
              {quote.massimale
                && (
                  <QuoteInformationResultItem>
                    <h6>Massimale:</h6>
                    <p>
                      {quote.massimale}
                    </p>
                  </QuoteInformationResultItem>
                )}
            </QuoteInformationResultContainer>
          </>
        )}
      {quote.company_id === 2 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>

            {quote.product_id === 1 && (
              <CompanyInfoElements
                onClick={() => {
                  let id = 6;

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'triglav') {
                    id = 34;
                  }

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'great_lakes') {
                    id = 31;
                  }

                  downloadResourceDocs(
                    id,
                    0,
                  );
                }}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}

            {quote.product_id === 3 && (
              <CompanyInfoElements
                onClick={() => {
                  let id = 7;

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'triglav') {
                    id = 35;
                  }

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'great_lakes') {
                    id = 32;
                  }

                  downloadResourceDocs(
                    id,
                    0,
                  );
                }}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}
            {quote.product_id === 2 && (
              <CompanyInfoElements
                onClick={() => {
                  let id = 22;

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'triglav') {
                    id = 36;
                  }

                  if (quote.quotation_data_prima && quote.quotation_data_prima.issuing_company === 'great_lakes') {
                    id = 33;
                  }

                  downloadResourceDocs(
                    id,
                    0,
                  );
                }}
                title="Informativa Precontrattuale"
              >
                <img src={preContractIcon} alt="" />
                <p>
                  Informativa Precontrattuale
                </p>
              </CompanyInfoElements>
            )}

          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote && quote.quotation_data_prima ? quote.quotation_data_prima.issuing_company : 'Ipitq ma'}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Diretta</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Risarcimento:</h6>
              <p>
                Rc con
                {' '}
                <b>Risarcimento</b>
                {' '}
                <br />
                {' '}
                <b>Diretto</b>
                {' '}
                e
                {' '}
                <b>RFS</b>
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
        </>
      )}
      {(quote.company_id === 11
        || quote.company_id === 12
        || quote.company_id === 13
        || quote.company_id === 14) && (
          <>
            <QuoteInformationResultContainer>
              <QuoteInformationResultItem>
                <h6>Compagnia:</h6>
                <p>{quote.company.name}</p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Emissione:</h6>
                <p>Tradizionale</p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Guida:</h6>
                <p>
                  {guideType.find((v) => v.id === requestInfo.guide_type).name}
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Frequenza pagamento:</h6>
                <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
              </QuoteInformationResultItem>
            </QuoteInformationResultContainer>
            <QuoteInformationResultContainer>
              <QuoteInformationResultItem>
                <h6>Risarcimento:</h6>
                <p>
                  Rc con
                  {' '}
                  <b>Risarcimento</b>
                  {' '}
                  <br />
                  {' '}
                  <b>Diretto</b>
                  {' '}
                  e
                  {' '}
                  <b>RFS</b>
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.autocarro_massimale.match(/[\d.,]+/)
                    ? quote.autocarro_massimale
                      .match(/[\d.,]+/)[0]
                      .replace(/\./g, '')
                    : quote.autocarro_massimale}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationResultItem>
              <QuoteInformationResultItem>
                <h6>Isotermici:</h6>
                <p>{quote.isotermici}</p>
              </QuoteInformationResultItem>
            </QuoteInformationResultContainer>
          </>
      )}
      {quote.company_id === null && (
        <>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.preventivas_company.company_name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Risarcimento:</h6>
              <p>
                Rc con
                {' '}
                <b>Risarcimento</b>
                {' '}
                <br />
                {' '}
                <b>Diretto</b>
                {' '}
                e
                {' '}
                <b>RFS</b>
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
        </>
      )}

      {showModalTutelaCircolazione && quote.company_id === 15 && quote.product_id === 9 && (
        <TutelaLegaleInfoModal quotation={quote} setShowModal={setShowModalTutelaCircolazione} />
      )}

      {showModal && quote.company_id === 16 && quote.product_id === 9 && (
        <GlobalAssistanceInfoModal quotation={quote} setShowModal={setShowModal} />
      )}

      {quote.company_id === 15 && quote.product_id === 9 && (
        <>
          <CompanyInformationContainer>

            <CompanyInfoElements onClick={() => openTutelaCircolazioneModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            <CompanyInfoElements onClick={() => downloadResourceDocs(23, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>Tutela Legale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>Annuo</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer className="ms-3 ms-sm-0">
            <QuoteInformationResultItem>
              <h6>Tempo medio di emissione:</h6>
              <p>2 giorni</p>
            </QuoteInformationResultItem>
            {quote.massimale != 0 && quote.massimale != null && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>

                  {Number(quote.massimale).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
            {quote.risk_massimale != 0 && quote.risk_massimale != null && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>

                  {Number(quote.risk_massimale).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}

      {quote.company_id === 4 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>

            {set_informativi[profession.profession] !== '' && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(8, profession.profession)}
                title={`${set_informativi[profession.profession]}`}
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>RC Professionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Professione:</h6>
              <p>{profession.profession_desc}</p>
            </QuoteInformationResultItem>
            {profession.billed_maximum != 0 && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(profession.billed_maximum).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer className="ms-3 ms-sm-0">
            <QuoteInformationResultItem>
              <h6>Franchigia:</h6>
              <p>1,000 &euro;</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Retroattività:</h6>
              <p>{profession.retroactivity_name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Scaglione fatturato:</h6>
              <p>
                {profession.billed}
                &euro;
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Tempo medio di emissione:</h6>
              <p>2 giorni</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
        </>
      )}

      {quote.company_id === 1001 && (quote.product_id === 1001 || quote.product_id === 1003 || quote.product_id === 1004) && (
        <CompanyInformationContainer>
          <CompanyInfoElements onClick={() => setShowModal(!showModal)}>
            <img src={infoIcon} alt="" />
            <p>Maggiori informazioni</p>
          </CompanyInfoElements>
          {(() => {
            const docMap = {
              1001: 44,
              1003: 47,
              1004: 49,
            };
            const docId = docMap[quote.product_id];
            if (!docId) return null;
            return (
              <CompanyInfoElements onClick={() => downloadResourceDocs(docId, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            );
          })()}
        </CompanyInformationContainer>
      )}

      {quote.company_id === 1002 && quote.product_id === 4 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>

            {set_informativi[profession.profession] !== '' && (
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(41, profession.profession)}
                title={`${set_informativi[profession.profession]}`}
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            )}
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>RC Professionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Professione:</h6>
              <p>{profession.profession_desc}</p>
            </QuoteInformationResultItem>
            {profession.billed_maximum != 0 && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(profession.billed_maximum).toLocaleString('it-IT', {
                    minimumFractionDigits: 2,
                  })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer className="ms-3 ms-sm-0">
            {quote.deductible
              && (
                <QuoteInformationResultItem>
                  <h6>Franchigia:</h6>
                  <p>
                    {' '}
                    {Number(quote.deductible).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                    {' '}
                    &euro;
                  </p>
                </QuoteInformationResultItem>
              )}
            {quote.deductible_plus
              && (
                <QuoteInformationResultItem>
                  <h6>Franchigia Incarichi:</h6>
                  <p>
                    {' '}
                    {Number(quote.deductible_plus).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                    {' '}
                    &euro;
                  </p>
                </QuoteInformationResultItem>
              )}
            {profession.retroactivity_name
              && (
                <QuoteInformationResultItem>
                  <h6>Retroattività:</h6>
                  <p>{profession.retroactivity_name}</p>
                </QuoteInformationResultItem>
              )}
            {profession.billed
              && (
                <QuoteInformationResultItem>
                  <h6>Scaglione fatturato:</h6>
                  <p>
                    {Number(profession.billed).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}

                    &euro;
                  </p>
                </QuoteInformationResultItem>
              )}

          </QuoteInformationResultContainer>
        </>
      )}

      {requestInfo.product_id == '12' && quote.company_id === 8 && (
        <>
          {showModal && (
            <SaluteInfoModal setShowModal={setShowModal} quote={quote} />
          )}
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            <CompanyInfoElements
              onClick={() => downloadResourceDocs(16, 0)}
              title="Informativa Precontrattuale"
            >
              <img src={preContractIcon} alt="" />
              <p>Informativa Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}

            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.risk_massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}

      {quote.company_id === 16 && quote.product_id == 10 && (
        <>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>Global Assistance</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            {(quote.massimale != 0 || quote.massimale != null) && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.product_id !== 11 ? `${new Intl.NumberFormat().format(quote.massimale)} €` : quote.massimale}
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}

      {showModal && quote.company_id == 8 && requestInfo.product_id == 11 && (
        <CasaInfoModal setShowModal={setShowModal} quote={quote} />
      )}
      {showModal && quote.company_id == 1001 && requestInfo.product_id == 1004 && (
        <RcFamigliaNobisModal setShowModal={setShowModal} quote={quote} />
      )}

      {showInfortunioModal && quote.product_id === 1002 && (
        <InvaliditaPermanenteInfortunio setShowModal={setShowInfortunioModal} />
      )}

      {showModal && ((quote.company_id === 8 || quote.company_id === 16) && quote.product_id === 13) && (
        <AncillariInfoModal setShowModal={setShowModal} quote={quote} />
      )}

      {(showModal && quote.company_id === 1001 && quote.product_id === 1001) && (
        <MalattiaNobisModal
          userData={quote}
          setShowModal={setShowModal}
        />
      )}
      {(showModal && quote.company_id === 1001 && quote.product_id === 1003) && (
        <CondominioNobisModal
          userData={quote}
          setShowModal={setShowModal}
        />
      )}

      {requestInfo.product_id == '11' && quote.company_id === 8 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}

            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.risk_massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}

      {requestInfo.product_id == '11' && quote.company_id === 16 && (
        <>

          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            <CompanyInfoElements
              onClick={() => downloadResourceDocs(39, 0)}
              title="Informativa Precontrattuale "
            >
              <img src={preContractIcon} alt="" />
              <p>{'Informativa Precontrattuale '}</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{safeCapitalizeWords(quote.product_name)}</p>
            </QuoteInformationResultItem>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.massimale}
                </p>
              </QuoteInformationResultItem>
            )}

            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.risk_massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}
      {requestInfo.product_id == '11' && quote.company_id === 1001 && (
        <>
          <QuoteInformationResultContainer>
            <CompanyInfoElements
              onClick={() => downloadResourceDocs(45, 0)}
              title="Informativa Precontrattuale "
            >
              <img src={preContractIcon} alt="" />
              <p>{'Informativa Precontrattuale '}</p>
            </CompanyInfoElements>
          </QuoteInformationResultContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}

            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                Tra &euro; 30,000 e &euro; 500,000
              </p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
        </>
      )}

      {requestInfo.product_id == '13' && quote.company_id === 8 && (
        <>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}

            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.risk_massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}

      {requestInfo.product_id == '13' && quote.company_id === 16 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            <CompanyInfoElements
              onClick={() => downloadResourceDocs(13, 0)}
              title="Informativa Precontrattuale"
            >
              <img src={preContractIcon} alt="" />
              <p>
                Informativa Precontrattuale
              </p>
            </CompanyInfoElements>
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}

            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {Number(
                    quote.risk_massimale
                      .replace(/[,.](?=\d{3})/g, '')
                      .replace(',', '.'),
                  ).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}
      {quote.company_id === 8 && requestInfo.product_id == 14 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {/* <CompanyInfoElements
              onClick={() => downloadResourceDocs(51, 0)} // Global Assistance
              title="Informativa Precontrattuale"
            >
              <img src={preContractIcon} alt="" />
              <p>
                Informativa Precontrattuale
              </p>
            </CompanyInfoElements> */}
            {requestInfo.sanitaria_stranieri && requestInfo.sanitaria_stranieri.is_resident === 1
              && (
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(54, 0)}
                  title="Informativa Precontrattuale"
                >
                  <img src={preContractIcon} alt="" />
                  <p>
                    Informativa Precontrattuale
                  </p>
                </CompanyInfoElements>
              )}
            {requestInfo.sanitaria_stranieri && requestInfo.sanitaria_stranieri.is_resident === 0
              && (
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(53, 0)}
                  title="Informativa Precontrattuale"
                >
                  <img src={preContractIcon} alt="" />
                  <p>
                    Informativa Precontrattuale
                  </p>
                </CompanyInfoElements>
              )}

          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>

            {quote.massimale != 0 && quote.massimale !== null && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {new Intl.NumberFormat('it-IT').format(quote.massimale)}
                  {' '}
                  &euro;
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}
      {quote.company_id === 19 && quote.product_id === 15 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            {(() => {
              const docMapping = {
                medici_dipendenti: 25,
                medici_liberi_professionisti: 27,
                medico_protetto: 26,
                professioni_sanitarie: 24,
              };
              let docId = docMapping[quote.sub_product];

              if (quote.product_id === 1000) {
                docId = 42;
              }

              if (!docId) return null;

              return (
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(docId, 0)}
                  title="Informativa Precontrattuale "
                >
                  <img src={preContractIcon} alt="" />
                  <p>{'Informativa Precontrattuale '}</p>
                </CompanyInfoElements>
              );
            })()}
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Sub Prodotto:</h6>
              <p>{getSubProductName(quote.sub_product)}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer className="ms-3 ms-sm-0">
            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                {Number(quote.massimale).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                })}
                {' '}
                &euro;
              </p>
            </QuoteInformationResultItem>

          </QuoteInformationResultContainer>
        </>
      )}

      {quote.company_id === 19 && quote.product_id === 1000 && (
        <>

          <QuoteInformationResultContainer>
            <CompanyInfoElements onClick={() => downloadResourceDocs(42, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                {Number(quote.massimale).toLocaleString('it-IT', {
                  minimumFractionDigits: 2,
                })}
                {' '}
                &euro;
              </p>
            </QuoteInformationResultItem>

          </QuoteInformationResultContainer>

        </>
      )}

      {quote.company_id === 1000 && (
        <>
          {quote.product_id === 1 && (
            <CompanyInformationContainer>
              <CompanyInfoElements onClick={() => downloadResourceDocs(30, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            </CompanyInformationContainer>
          )}
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Risarcimento:</h6>
              <p>
                Rc con
                {' '}
                <b>Risarcimento</b>
                {' '}
                <br />
                {' '}
                <b>Diretto</b>
                {' '}
                e
                {' '}
                <b>RFS</b>
              </p>
            </QuoteInformationResultItem>
            {/* <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationResultItem> */}
          </QuoteInformationResultContainer>
        </>
      )}
      {quote.company_id === 19 && quote.product_id === 1002 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openInfortunioModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>
            <CompanyInfoElements onClick={() => downloadResourceDocs(46, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>

            {quote.massimale
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    {Number(quote.massimale).toLocaleString('it-IT', {
                      minimumFractionDigits: 2,
                    })}
                    {' '}
                    &euro;
                  </p>
                </QuoteInformationResultItem>
              )}
            <QuoteInformationResultItem>
              <h6>Nome Prodotto:</h6>
              <p>{quote.product_name}</p>

            </QuoteInformationResultItem>

          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>
                Operatività della copertura:
              </h6>
              <p>
                H24 per il Contraente/Assicurato
                <br />
                Rischio Extra-Professionale per gli Assicurati Addizionali, componenti il Nucleo Familiare
              </p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>

        </>
      )}

      {quote.company_id === 16 && quote.product_id == 9 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => openModal()}>
              <img src={infoIcon} alt="" />
              <p>Maggiori informazioni</p>
            </CompanyInfoElements>

            {(() => {
              const docMap = {
                patente_motor: 37,
                vita_privata: 38,
                tutela_professionale: 48,
              };
              const docId = docMap[quote.sub_product];
              if (!docId) return null;
              return (
                <CompanyInfoElements
                  onClick={() => downloadResourceDocs(docId, 0)}
                  title="Informativa Precontrattuale"
                >
                  <img src={preContractIcon} alt="" />
                  <p>
                    Informativa Precontrattuale
                  </p>
                </CompanyInfoElements>
              );
            })()}

          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>Global Assistance</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{quote.product_name}</p>
            </QuoteInformationResultItem>

            {(quote.sub_product === 'vita_privata' || quote.sub_product === 'tutela_professionale') && (
              <>
                {quote.quote_massimale
                  && (
                    <QuoteInformationResultItem>
                      <h6>Massimale:</h6>
                      <p>
                        {' '}
                        {new Intl.NumberFormat().format(quote.quote_massimale)}
                        €
                      </p>
                    </QuoteInformationResultItem>
                  )}

              </>
            )}
          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            {quote.massimale != 0 && quote.massimale !== null && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {new Intl.NumberFormat().format(quote.massimale)}
                  €
                </p>
              </QuoteInformationResultItem>
            )}

            {quote.sub_product === 'patente_motor' && (
              <>
                {quote.quote_massimale
                  && (
                    <QuoteInformationResultItem>
                      <h6>Massimale:</h6>
                      <p>
                        {' '}
                        {new Intl.NumberFormat().format(quote.quote_massimale)}
                        €
                      </p>
                    </QuoteInformationResultItem>
                  )}

              </>
            )}

          </QuoteInformationResultContainer>

        </>
      )}
      {quote.company_id === 1001 && quote.product_id != 11 && (
        <>
          {/* {quote.product_id == 1004
         && (
         <CompanyInformationContainer>
           <CompanyInfoElements onClick={() => openFamigliaNobisModal()}>
             <img src={preContractIcon} alt="" />
             <p>Maggiori informazioni</p>
           </CompanyInfoElements>
         </CompanyInformationContainer>
         )} */}

          {quote.product_id === 1 && (
            <CompanyInformationContainer>

              <CompanyInfoElements onClick={() => downloadResourceDocs(43, 0)} title="Informativa Precontrattuale">
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>

            </CompanyInformationContainer>
          )}

          {quote.product_id === 10 && (
            <CompanyInformationContainer>
              <CompanyInfoElements
                onClick={() => downloadResourceDocs(40, 0)}
              >
                <img src={preContractIcon} alt="" />
                <p>Informativa Precontrattuale</p>
              </CompanyInfoElements>
            </CompanyInformationContainer>
          )}

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>
                {requestInfo?.product?.id === 1 && 'RC Auto'}
                {requestInfo?.product_id == 10 && 'Commercio Su Misura'}
                {(requestInfo.product_id == 1001 || requestInfo.product_id == 1004) && quote.product_name}
                {requestInfo.product_id == 1003 && requestInfo.product.name}

              </p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>
                {quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}
              </p>
            </QuoteInformationResultItem>
          </QuoteInformationResultContainer>

          <QuoteInformationResultContainer>
            {quote.massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {new Intl.NumberFormat().format(quote.massimale)}
                  €
                </p>
              </QuoteInformationResultItem>
            )}
            {requestInfo.product_id == 1003
              && (
                <QuoteInformationResultItem>
                  <h6>Nome Prodotto:</h6>
                  <p>
                    {quote.product_name}
                  </p>
                </QuoteInformationResultItem>
              )}
          </QuoteInformationResultContainer>

          {quote.product_id === 1 && (
            <QuoteInformationResultItem>
              <h6>Massimale:</h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][1] : "1'050'000"}
                  &euro;
                </b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationResultItem>
          )}
        </>
      )}

      {quote.company_id === 1006 && quote.product_id === 1006 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => downloadResourceDocs(52, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Prodotto:</h6>
              <p>{requestInfo.product.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Emissione:</h6>
              <p>Tradizionale</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>

          </QuoteInformationResultContainer>
          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Paccheto:</h6>
              <p>{monopattiniPackage.find((e) => e.id === quote.code).name}</p>
            </QuoteInformationResultItem>

            {quote.massimale
              && (
                <QuoteInformationResultItem>
                  <h6>Massimale:</h6>
                  <p>
                    <b>
                      {Number(quote.massimale).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      &euro;
                    </b>
                    {' '}
                    Danni a persone
                    <br />
                    <b>
                      {Number(10000).toLocaleString('it-IT', {
                        minimumFractionDigits: 2,
                      })}
                      &euro;
                    </b>
                    {' '}
                    Danni a cose
                  </p>
                </QuoteInformationResultItem>
              )}

          </QuoteInformationResultContainer>

        </>
      )}

      {quote.company_id === 1010 && requestInfo.product_id == 1 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => downloadResourceDocs(58, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.risk_massimale}
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}
      {quote.company_id === 1011 && requestInfo.product_id == 1 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => downloadResourceDocs(59, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.risk_massimale}
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}

      {quote.company_id === 23 && requestInfo.product_id == 1 && (
        <>
          <CompanyInformationContainer>
            <CompanyInfoElements onClick={() => downloadResourceDocs(64, 0)}>
              <img src={preContractIcon} alt="" />
              <p>Informazione Precontrattuale</p>
            </CompanyInfoElements>
          </CompanyInformationContainer>

          <QuoteInformationResultContainer>
            <QuoteInformationResultItem>
              <h6>Compagnia:</h6>
              <p>{quote.company.name}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Frequenza pagamento:</h6>
              <p>{quote.payment_frequency === 1 ? 'Annuo' : 'Semestrale'}</p>
            </QuoteInformationResultItem>
            <QuoteInformationResultItem>
              <h6>Guida:</h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationResultItem>
            {quote.risk_massimale && (
              <QuoteInformationResultItem>
                <h6>Massimale:</h6>
                <p>
                  {quote.risk_massimale}
                </p>
              </QuoteInformationResultItem>
            )}
          </QuoteInformationResultContainer>
        </>
      )}
    </>
  );
}

export default QuoteInfoComponentResult;
